var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideCameraSketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 432,
    viewBox: "0 0 423 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.46 398.457C303.562 398.457 383.09 318.93 383.09 220.827C383.09 122.725 303.562 43.1973 205.46 43.1973C107.358 43.1973 27.83 122.725 27.83 220.827C27.83 318.93 107.358 398.457 205.46 398.457Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.46 393.127C300.619 393.127 377.76 315.986 377.76 220.827C377.76 125.669 300.619 48.5273 205.46 48.5273C110.301 48.5273 33.16 125.669 33.16 220.827C33.16 315.986 110.301 393.127 205.46 393.127Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.24 283.987C267.213 283.987 315.83 235.37 315.83 175.397C315.83 115.425 267.213 66.8074 207.24 66.8074C147.267 66.8074 98.65 115.425 98.65 175.397C98.65 235.37 147.267 283.987 207.24 283.987Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.24 277.157C263.44 277.157 309 231.598 309 175.397C309 119.197 263.44 73.6372 207.24 73.6372C151.039 73.6372 105.48 119.197 105.48 175.397C105.48 231.598 151.039 277.157 207.24 277.157Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.24 252.467C249.805 252.467 284.31 217.962 284.31 175.397C284.31 132.833 249.805 98.3271 207.24 98.3271C164.675 98.3271 130.17 132.833 130.17 175.397C130.17 217.962 164.675 252.467 207.24 252.467Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M207.24 236.387C240.924 236.387 268.23 209.081 268.23 175.397C268.23 141.713 240.924 114.407 207.24 114.407C173.556 114.407 146.25 141.713 146.25 175.397C146.25 209.081 173.556 236.387 207.24 236.387Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M207.24 229.987C237.389 229.987 261.83 205.547 261.83 175.397C261.83 145.248 237.389 120.807 207.24 120.807C177.091 120.807 152.65 145.248 152.65 175.397C152.65 205.547 177.091 229.987 207.24 229.987Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.24 192.837C219.556 192.837 229.54 182.853 229.54 170.537C229.54 158.221 219.556 148.237 207.24 148.237C194.924 148.237 184.94 158.221 184.94 170.537C184.94 182.853 194.924 192.837 207.24 192.837Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.52 293.827H149.44V325.947H178.52V293.827Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268.23 293.827H239.15V325.947H268.23V293.827Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.88 299.477H190.39V328.267H228.88V299.477Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.37 51.2473L199.03 63.9673H213.71L206.37 51.2473Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.32 286.367C40.32 286.367 -12.47 163.897 44.83 78.5272C44.83 78.5272 74.02 28.3872 133.16 28.1772C192.3 27.9672 229.54 28.1772 229.54 28.1772C229.54 28.1772 379.64 17.7572 387.45 207.017C387.45 207.017 384.99 252.477 370.06 287.677",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.44738L21.1 393.127C21.1 393.127 137.72 433.597 209.63 429.837C281.54 426.077 418.71 316.397 421.6 185.017C421.6 185.017 419.57 102.487 334.79 43.1874C250.01 -16.1126 2 4.44738 2 4.44738Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideCameraSketch);
export default __webpack_public_path__ + "static/media/side-camera-sketch.d1affc0694207ceae60c750ac58c7bad.svg";
export { ForwardRef as ReactComponent };